import React, { useState } from "react";
import { VerifyInstantPayment } from "../../../pages";
import * as yup from "yup";
import { MimaToastUtil } from "../../../components";
import constant from "../../../utils/constant";
import { MoneyExController } from "../../../controllers";

const VerifyInstantPaymentContainer = ({ closeModal, singleItem }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return yup.object().shape({
      buyerStatus: yup.string().required("Select Status"),
      buyerPaymentDateTime: yup
        .string()
        .required("Time Payment was recieved is required"),
    });
  };
  const statusData = [
    { key: "PAID", value: "PAID" },
    { key: "FALSE-PAYMENT", value: "FALSE-PAYMENT" },
  ];

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      amount: values.amount,
      buyerPaymentDateTime: values.buyerPaymentDateTime,
      buyerStatus: values.buyerStatus,
      moneyExOrderId: singleItem._id,
      note: values.note,
    };

    const { status, errorMessage } =
      await MoneyExController.verifyInstantOrderPayment(payload);
    if (status === constant.Success) {
      MimaToastUtil.success({ message: "Payment verified successfully" });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };
  return (
    <VerifyInstantPayment
      closeModal={closeModal}
      singleItem={singleItem}
      statusData={statusData}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      loading={loading}
    />
  );
};

export default VerifyInstantPaymentContainer;
